import { interval, Observable } from "rxjs";
import { Subject } from "rxjs";
import { Subscription } from "rxjs";
import { LogService } from "../../logger/loggerProvider/loggerhelper.service";
import { SubscriptionWsi, SubscriptionDeleteWsi } from '../../signalr';
import { ValueDetails } from '../../interfaces/wsi.value.data';

export const defaultClientId: string = "defaultClient";
const instrumentationInterval: number = 30;

export class ValueSubscriptionProxy {

  private static counter: number = 0;

  public _notifyProxy: Subject<ValueDetails[]> = new Subject<ValueDetails[]>();
  private subscribedIds: Map<string, SubscriptionWsi[]> = new Map<string, SubscriptionWsi[]>();
  private subscriptionKeysToPropertyId: Map<number, string> = new Map<number, string>();
  private _clientId: string;
  private eventsSubscription: Subscription;
  private timerSubscription: Subscription;

  public constructor(
    private valueHubEvents: Observable<ValueDetails[]>,
    clientName: string, private loggerHelper: LogService, ) {
    if (clientName !== undefined) {
      this._clientId = clientName + ":" + ValueSubscriptionProxy.counter.toString();
    } else {
      this._clientId = defaultClientId;
    }
    ValueSubscriptionProxy.counter++;
    this.eventsSubscription = this.valueHubEvents.subscribe(values => this.onDispatchValues(values), error => this.onDispatchValuesError(error));
    this.timerSubscription = interval(instrumentationInterval * 1000).subscribe(value => this.onTimer(value));
  }

  public dispose(): void {
    if ((this.subscribedIds.size > 0) || (this.subscriptionKeysToPropertyId.size > 0)) {
      this.subscribedIds.clear();
      this.subscriptionKeysToPropertyId.clear();
    }
    if (this.eventsSubscription != undefined) {
      this.eventsSubscription.unsubscribe();
    }
    if (this.timerSubscription != undefined) {
      this.timerSubscription.unsubscribe();
    }
  }

  public get clientId(): string {
    return this._clientId;
  }

  public get valueNotification(): Observable<ValueDetails[]> {
    return this._notifyProxy.asObservable();
  }

  public addSubscription(subWsi: SubscriptionWsi): void {
    this.subscriptionKeysToPropertyId.set(subWsi.Key, subWsi.PropertyId);
    if (this.subscribedIds.has(subWsi.PropertyId) === true) {
      this.subscribedIds.get(subWsi.PropertyId).push(subWsi);
    }
    else {
      this.subscribedIds.set(subWsi.PropertyId, [subWsi]);
    }
  }

  public removeSubscription(subWsiDel: SubscriptionDeleteWsi): void {
    let propertyId: string = this.subscriptionKeysToPropertyId.get(subWsiDel.Key);
    let subscriptions: SubscriptionWsi[] = this.subscribedIds.get(propertyId);
    if (subscriptions != undefined) {
      let idx: number = subscriptions.findIndex(value => value.Key === subWsiDel.Key);
      if (idx !== -1) {
        subscriptions.splice(idx, 1);
      }
      if (subscriptions.length === 0) {
        this.subscribedIds.delete(propertyId);
      }
    }
    this.subscriptionKeysToPropertyId.delete(subWsiDel.Key);
  }
  
  public getNoOfSubscriptions(): number {
    return this.subscriptionKeysToPropertyId.size;
  }

  private onDispatchValues(values: ValueDetails[]): void {
    let filtered: ValueDetails[] = values.filter(value => this.subscribedIds.has(value.OriginalObjectOrPropertyId));
    if (filtered.length > 0) {
      this._notifyProxy.next(filtered);
    }
  }

  private onDispatchValuesError(error: any): void {
    this._notifyProxy.error(error);
  }

  private onTimer(counter: number): void {
    this.loggerHelper.logInfo(ValueSubscriptionProxy.name, "ValueSubscriptionProxy Counter :" + ValueSubscriptionProxy.counter);
  }
}
